import React, { useState, useEffect } from "react";
import { GoClock } from "react-icons/go";
import { IoCheckmark } from "react-icons/io5";
import './JobDetails.scss';
import { format } from 'date-fns';

export default function JobActivity({activities= []}) {
  useEffect(() => {
    console.log("Activities:", activities);
}, [activities]);

    return (
         <section className="activity-wrapper job-activity">
           {activities?.map((activity, index) => {
                const isFutureDate = new Date(activity?.activityDate) > new Date();
                return (
                  <div 
                    className={`activity-holder d-flex gap-3 position-relative ${isFutureDate ? '' : 'completed'}`} 
                    key={index}
                  >
                    <div className="dateInfo">
                      <span><GoClock /></span>
                      {format(new Date(activity?.activityDate), 'dd MMM yyyy')}
                    </div>
                    <span className="icon">
                      <IoCheckmark />
                    </span>
                    <div className="activity-info">
                      <h6>{activity?.actionTaken}</h6>
                      <p className="mb-0"><span>Action taken :</span> {activity?.outcome}</p>
                      <p className="mb-0"><span>Action Taken by :</span> {activity?.userName}</p>
                    </div>
                  </div>
                );
              })}
             {/* activity repeat start here }
             <div className="activity-holder d-flex gap-3 position-relative completed">
               <div className="dateInfo">
                 <span>  <GoClock /> </span>
                 20 Dec 2024
               </div>
               <span className="icon">
                 <IoCheckmark />
               </span>
               <div className="activity-info">
                 <h6>Interview - Technical</h6>
                 <p className="mb-0"><span>Candidate :</span>  Melgibson</p>
                 <p className="mb-0"><span>Conducted by :</span>  Henry</p>
                 <p className="mb-0"><span>Action taken :</span>  Selected for next level</p>
               </div>
             </div>
             {/* activity repeat ends here */}              
       
           </section>
    );
}
